module.exports = __webpack_public_path__ + "static/media/rightArrowFootball.b12be70e.svg";